<micro-maps [allowEdit]="false" [showCompany]="false"></micro-maps>
